import React, { memo, useContext } from 'react';
import { bool, oneOf, string, number } from 'prop-types';
import { AppContext } from '@prisjakt/ui-app-context';
import {
  InStockIcon,
  IncomingIcon,
  OutOfStockIcon,
  StockUnknownIcon,
} from '@prisjakt/ui-icons';
import * as S from './styles';

const STATUSES = ['in_stock_preorder', 'incoming', 'in_stock', 'not_in_stock'];

const getClassicIconComponent = status => {
  switch (status) {
    case 'in_stock_preorder':
    case 'incoming':
      return IncomingIcon;
    case 'in_stock':
      return InStockIcon;
    case 'not_in_stock':
      return OutOfStockIcon;
    default:
      return StockUnknownIcon;
  }
};

const getStatusText = (status, statusText, t) =>
  status === 'incoming' && statusText
    ? statusText.replace(/-/g, '‑') // Replace hyphen with hard hyphen to prevent row break in date (Eg in 2019-08-10).
    : t('product', `stock-status.${status || 'unknown'}`);

const StockStatus = props => {
  const {
    className,
    status,
    statusText,
    toneDown,
    classicIcons,
    showText,
    tooltip,
    width,
    height,
  } = props;

  const { t } = useContext(AppContext);

  let icon = null;
  if (classicIcons) {
    const Icon = getClassicIconComponent(status);
    icon = <Icon toneDown={toneDown} width={width} height={height} />;
  } else {
    icon = <S.Icon status={status} toneDown={toneDown} />;
  }

  return (
    <S.Tooltip placement="left" title={tooltip} className={className}>
      <S.IconAndText>
        {icon}
        {showText && (
          <S.Text toneDown={toneDown}>
            {getStatusText(status, statusText, t)}
          </S.Text>
        )}
      </S.IconAndText>
    </S.Tooltip>
  );
};

StockStatus.propTypes = {
  className: string,
  status: oneOf(STATUSES),
  statusText: string,
  toneDown: bool,
  showText: bool,
  classicIcons: bool,
  tooltip: string,
  width: number,
  height: number,
};

StockStatus.defaultProps = {
  className: undefined,
  status: null,
  statusText: undefined,
  toneDown: false,
  showText: true,
  classicIcons: false,
  tooltip: '',
  width: undefined,
  height: undefined,
};

export default memo(StockStatus);
